/*
 *
 * userProfiling Api
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 18-10-2024
 */

import { axiosInstance as axios } from 'Api'
import { handlingResponse } from 'Utility/globalMethods'
if (process.env.ISMOCK === 'true') {
  try {
    require('Mocks/userProfiling/userProfiling')
  } catch (error) {
    console.error('Error loading info mock:', error)
  }
}

export async function getTabBar (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/getTabBar', // TODO - cambiare con url esatto
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function profiling (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/merchant-service/profiling',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getNewMessages (params) {
  let data
  const type = `?type=${params.payload || 'ALL'}` // COMMUNICATIONS, ALERTS, ALL

  try {
    data = await axios({
      method: 'get',
      url: `services/communication-service/communications/new-messages${type}`
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getNewDocuments (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/document-service/new-documents',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

let currentController = null

export async function getShopList (params) {
  let data
  if (currentController) {
    currentController.abort()
  }
  currentController = new AbortController()
  const { signal } = currentController
  try {
    data = await axios({
      method: 'get',
      url: '/services/merchant-service/shop-selector/shops',
      params: { ...params },
      signal
    })
    currentController = null
    return handlingResponse(data)
  } catch (error) {
    if (error.name === 'AbortError') {
      return { error: 'Request cancelled' }
    }
    currentController = null
    return handlingResponse(error)
  }
}

let currentCostsController = null
export async function getCostsShopList (params = {}) {
  let data
  if (currentCostsController) {
    currentCostsController.abort()
  }
  currentCostsController = new AbortController()
  const { signal } = currentCostsController

  try {
    data = await axios({
      method: 'get',
      url: '/services/merchant-service/commissions/shop-selector/shops',
      params: { ...params }, // ← Passa i parametri come query parameters
      signal
    })
    currentCostsController = null
    return handlingResponse(data)
  } catch (error) {
    if (error.name === 'AbortError') {
      return { error: 'Request cancelled' }
    }
    currentCostsController = null
    return handlingResponse(error)
  }
}

export async function setShopSelection (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/merchant-service/shop-selector/shops',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function setCostsShopSelection (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/merchant-service/commissions/shop-selector/shops',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

let currentDisputeController = null
export async function getDisputeShopList (params = {}) {
  let data
  if (currentDisputeController) {
    currentDisputeController.abort()
  }
  currentDisputeController = new AbortController()
  const { signal } = currentDisputeController

  try {
    data = await axios({
      method: 'get',
      url: '/services/merchant-service/disputes/shop-selector/shops',
      params: { ...params },
      signal
    })
    currentDisputeController = null
    return handlingResponse(data)
  } catch (error) {
    if (error.name === 'AbortError') {
      return { error: 'Request cancelled' }
    }
    currentDisputeController = null
    return handlingResponse(error)
  }
}

export async function setDisputeShopSelection (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/merchant-service/disputes/shop-selector/shops',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getShopListGt (params) {
  let data
  const { pageNumber = 0, pageSize = 15 } = params || {}

  try {
    data = await axios({
      method: 'get',
      url: `/services/merchant-service/shop-selector/shops-with-gt-source?pageNumber=${pageNumber}&pageSize=${pageSize}`,
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function getStatusAml (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/merchant-service/public/aml/status',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function getResultsGraphViewed (params) {
  let data
  try {
    data = await axios({
      method: 'get',
      url: '/services/transaction-service/dashboard/chart?period=LAST30DAYS',
      cancelOnRouteChange: true,
      params: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function updateTutorial (params) {
  let data

  try {
    data = await axios({
      method: 'put',
      url: '/services/merchant-service/user/updateTutorial',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function getServiceQuickLinks (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/merchant-service/home-page/widget',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
// @generator api:method
